import {
  ListItemButton,
  ListItemText,
  Drawer,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Menu, useSidebarState } from 'react-admin';
import { DRAWER_WIDTH, USER_ROLE } from '../constant';
import { useCognitoUser } from '../hooks';

const MenuItem = styled(ListItemButton)(({theme}) => ({
  padding: '14px 16px',
}));

const CustomMenu = () => {
  const [open] = useSidebarState();
  const currentUser = useCognitoUser();
  
  const isCustomer = currentUser.group === USER_ROLE.Customer;
  const isOperatorOrCustomer = [USER_ROLE.Operator, USER_ROLE.Customer].includes(currentUser.group);
  const isAppAdmin = currentUser.group === USER_ROLE.AppAdmin;

  const menuItems = [
    {
      show: !isCustomer,
      href: '#/overview',
      label: 'Virtual Patrol'
    },
    {
      show: true,
      href: '#/logs',
      label: 'Logs'
    },
    {
      show: true,
      href: '#/reports',
      label: 'Report'
    },
    {
      show: !isOperatorOrCustomer,
      href: '#/cognitoUsers',
      label: 'Users'
    },
    {
      show: isAppAdmin,
      href: '#/checkpoints',
      label: 'Checkpoint'
    },
    {
      show: !isOperatorOrCustomer,
      href: '#/routes',
      label: 'Route'
    },
    {
      show: !isOperatorOrCustomer,
      href: '#/schedules',
      label: 'Schedule'
    }
  ];

  return (
    <Drawer
      variant="permanent"
      open={open}
      sx={{
        width: open ? DRAWER_WIDTH : 0,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: open ? DRAWER_WIDTH : 0,
          boxSizing: 'border-box',
          transition: 'width 0.3s',
        },
      }}
    >
      <Menu>
        {menuItems
          .filter(item => item.show)
          .map(item => (
            <MenuItem key={item.href} component="a" href={item.href}>
              {open && <ListItemText primary={item.label} />}
            </MenuItem>
          ))
        }
      </Menu>
    </Drawer>
  );
};

export default CustomMenu;

